import { render, staticRenderFns } from "./TrangNhatKyOtp.vue?vue&type=template&id=1efa6a32&"
import script from "./TrangNhatKyOtp.vue?vue&type=script&lang=js&"
export * from "./TrangNhatKyOtp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports